import { makeStyles } from '@material-ui/core';

export const useRadioButtonStyles = makeStyles((theme) => ({
  root: (props) => ({
    textAlign: 'left',
  }),
}));
